import React from 'react';

class ProgressBar extends React.Component {
    render() {
        return (
            <div className="spinner-wrap">
                <div className="spinner">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                </div>
            </div>
        );
    }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./app/components/controls/progressBar/ProgressBar.jsx